var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14985"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 20.5,
    cy: 20.5,
    r: 18.5,
    fill: "url(#paint0_linear_2093_2529)",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4616 21.593H28.2526V17.3462C28.2526 17.0647 28.1385 16.7946 27.9354 16.5955C27.7323 16.3964 27.4568 16.2846 27.1695 16.2846V12.7891C27.1686 12.6628 27.137 12.5385 27.0773 12.4266C27.0176 12.3147 26.9316 12.2183 26.8264 12.1455C26.7211 12.0726 26.5996 12.0254 26.4721 12.0078C26.3445 11.9902 26.2145 12.0026 26.0928 12.044L12.7917 16.0486C12.057 16.2721 12 16.6695 12 17.3462V27.9383C11.9992 28.0779 12.0266 28.2164 12.0808 28.3456C12.1349 28.4747 12.2146 28.5921 12.3154 28.6909C12.4161 28.7896 12.5358 28.8678 12.6676 28.9208C12.7994 28.9739 12.9406 29.0008 13.0831 29H27.1695C27.312 29.0008 27.4532 28.9739 27.585 28.9208C27.7168 28.8678 27.8365 28.7896 27.9373 28.6909C28.038 28.5921 28.1177 28.4747 28.1719 28.3456C28.226 28.2164 28.2534 28.0779 28.2526 27.9383V24.7781H28.4616C28.605 24.7764 28.7419 24.7195 28.8427 24.6195C28.9435 24.5195 29 24.3847 29 24.2441V22.1207C29 21.9808 28.9433 21.8465 28.8423 21.7476C28.7413 21.6486 28.6044 21.593 28.4616 21.593ZM25.8204 13.3354C25.9851 13.2857 26.0928 13.3354 26.0928 13.5279V16.2846H15.8446L25.8204 13.3354ZM27.1695 27.4292C27.1649 27.5617 27.1095 27.6877 27.0145 27.782C26.9194 27.8763 26.7916 27.9321 26.6565 27.9383H13.6405C13.4977 27.9383 13.3608 27.8827 13.2598 27.7837C13.1588 27.6848 13.1021 27.5505 13.1021 27.4106V17.9112C13.1021 17.489 13.1718 17.3462 13.6658 17.3462H26.6565C26.7277 17.3462 26.7982 17.3601 26.864 17.387C26.9297 17.4139 26.9894 17.4533 27.0394 17.503C27.0895 17.5527 27.129 17.6116 27.1557 17.6763C27.1824 17.7411 27.1957 17.8104 27.1949 17.8802V21.6054H24.465C24.3943 21.6054 24.3243 21.6191 24.259 21.6456C24.1936 21.6721 24.1343 21.711 24.0843 21.76C24.0343 21.809 23.9946 21.8672 23.9676 21.9312C23.9405 21.9952 23.9266 22.0638 23.9266 22.1332V24.2565C23.9266 24.3971 23.9831 24.532 24.0839 24.6319C24.1847 24.7319 24.3216 24.7888 24.465 24.7905H27.1695V27.4292ZM27.9169 23.704H25.0097V22.6547H27.9232L27.9169 23.704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2093_2529",
    x1: 37,
    y1: 20.5,
    x2: 4,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.f880087172a6cfabfd67ab46511ae5f6.svg";
export { ForwardRef as ReactComponent };